import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ColumnMode, SelectionType, DatatableComponent } from '@swimlane/ngx-datatable';

import { IssueUpdateDataSupplier, IssuesFilterSupplier, QuproList, IssueSupplier, QuproServiceError, BaseUser } from '@arpada/arp-lib-common-qupro';

import { IssueFront, RowModel, Page } from '../../../models/api.models';
import { PortalProveedorService, IssuePopulateService, UiService, GeneralPopulateService } from '../../../services/api.services';


import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { IssueData } from '../issue.data';

@Component({
  selector: 'app-editar-issue-escritorio',
  templateUrl: './editar-issue-escritorio.component.html',
  styleUrls: ['./editar-issue-escritorio.component.scss'],
})
export class EditarIssueEscritorioComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;

  @Input() issuePostsaleData: IssueData;
  @Input() fromWhere: string;
  @Output() giveMeIssues = new EventEmitter();
  @Output() issueUpdateInlineEvent = new EventEmitter();

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  selected = [];
  page = new Page();
  showSpinner = -1;
  frozenLeft = true;
  supplierUser: BaseUser = new BaseUser();

  constructor(private uiService: UiService,
              private modalCtrl: ModalController,
              private portalProveedorService: PortalProveedorService,
              private issuePopulateService: IssuePopulateService,
              private generalPopulateService: GeneralPopulateService) { }

  ngOnInit() {
    this.frozenLeft = this.generalPopulateService.isPlatformDesktop();
    this.portalProveedorService.getSupplierData().subscribe((baseUser: BaseUser) => {
      this.supplierUser = baseUser;
    });
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  getOperario(eventInfo, rowIndex) {
    // tengo que hacer este seteo porque si no siempre tiene el valor de la inicializacion
    this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.operator_num = Number(eventInfo.detail.value);
  }

  clearDate(date: string, eventInfo, rowIndex, row) {
    if (date === 'appointmentDate') {
      this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.appointment_date = '';
    }
    if (date === 'materialDate') {
      this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.material_date = '';
    }
    if (date === 'repairDate') {
      this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.repair_date = '';
    }
  }

  setPage(pageInfo) {
    this.issuePostsaleData.page.offset = pageInfo.offset;
    const envio = {
      page: this.issuePostsaleData.page,
      total: this.issuePostsaleData.page.count
    };
    this.giveMeIssues.emit(envio);
  }

  cancel(row: IssueFront, rowIndex) {
    this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.operator_num = row.operatorFront.id;
    this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.supplier_comment = row.supplier_comment;
    this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.material_date =
                                                                this.issuePopulateService.getFormatDate(row.material_date);
    this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.appointment_date =
                                                                this.issuePopulateService.getFormatDate(row.appointment_date);
    this.issuePostsaleData.rowsModelDataToUpdate[rowIndex].frontInputsToUpdate.repair_date =
                                                                this.issuePopulateService.getFormatDate(row.repair_date);
  }

  accept(row: IssueFront, rowIndex) {
    this.showSpinner = rowIndex;
    const seHaModificadoAppDate = this.seHaModificadoAppDate(row, this.issuePostsaleData.rowsModelDataToUpdate[rowIndex]);
    const seHaModificadoRepairDate = this.seHaModificadoRepairDate(row, this.issuePostsaleData.rowsModelDataToUpdate[rowIndex]);
    const seHaModificadoMaterialDate = this.seHaModificadoMaterialDate(row, this.issuePostsaleData.rowsModelDataToUpdate[rowIndex]);
    const seHaModificadoComentario = this.seHaModificadoComentario(row, this.issuePostsaleData.rowsModelDataToUpdate[rowIndex]);
    const seHaModificadoOperario = this.seHaModificadoOperario(row, this.issuePostsaleData.rowsModelDataToUpdate[rowIndex]);
    const material: number = this.setMaterial(row, this.issuePostsaleData.rowsModelDataToUpdate[rowIndex]);

    const issueToUpdate: IssueUpdateDataSupplier =
      this.createIssueUpdateDataSupplier(this.issuePostsaleData.rowsModelDataToUpdate[rowIndex], material,
      seHaModificadoAppDate, seHaModificadoRepairDate, seHaModificadoMaterialDate, seHaModificadoComentario, seHaModificadoOperario);
    this.portalProveedorService.updateIssue(row.id, issueToUpdate).subscribe(() => {
      this.showSpinner = -1;
      const issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
      issuesFilter.id = row.id;
      if (this.fromWhere === 'postsale') {
        this.portalProveedorService.getPostSaleIssuesFromCsiteSupplier('all', issuesFilter, null, 0, 0)
          .subscribe((resp: QuproList<IssueSupplier>) => {
            const updateIssue = this.issuePopulateService.convertirIssueSupplierToPostsaleFrontIssue(resp.elements[0]);
            const message = 'id: ' + updateIssue.id + ' actualizada con éxito. ';
            this.showOkToast(message);
            this.issueUpdateInlineEvent.emit(updateIssue);
          }, (error: QuproServiceError) => {
            const message = 'id: ' + row.id + ': ' + error.message;
            this.showErrorToast(message);
          });
      }
      if (this.fromWhere === 'mantenimiento') {
        this.portalProveedorService.getMantenimientoIssuesFromCsiteSupplier(issuesFilter, null, 0, 0)
          .subscribe((resp: QuproList<IssueSupplier>) => {
            const updateIssue = this.issuePopulateService.convertirIssueSupplierToPostsaleFrontIssue(resp.elements[0]);
            const message = 'id: ' + updateIssue.id + ' actualizada con éxito. ';
            this.showOkToast(message);
            this.issueUpdateInlineEvent.emit(updateIssue);
          }, (error: QuproServiceError) => {
            const message = 'id: ' + row.id + ': ' + error.message;
            this.showErrorToast(message);
          });
      }
    }, (error: QuproServiceError) => {
      this.showSpinner = -1;
      const message = 'id: ' + row.id + ': ' + error.message;
      this.showErrorToast(message);
    });
  }

  private showOkToast(message: string) {
    this.uiService.showSimpleBottomToast(message, 2000);
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

  private createIssueUpdateDataSupplier(rowModel: RowModel, material: number, seHaModificadoAppDate: boolean,
                                        seHaModificadoRepairDate: boolean, seHaModificadoMaterialDate: boolean,
                                        seHaModificadoComentario: boolean, seHaModificadoOperario: boolean): IssueUpdateDataSupplier{
    const issueUpdateDataSupplier: IssueUpdateDataSupplier = new IssueUpdateDataSupplier();
    if (seHaModificadoAppDate) {
      if (rowModel.frontInputsToUpdate.appointment_date === ''){
        issueUpdateDataSupplier.appointment_date = null;
      } else {
        issueUpdateDataSupplier.appointment_date = new Date(rowModel.frontInputsToUpdate.appointment_date).getTime().toString();
      }
    }
    if (seHaModificadoRepairDate) {
      if (rowModel.frontInputsToUpdate.repair_date === '') {
        issueUpdateDataSupplier.repair_date = null;
      } else {
        issueUpdateDataSupplier.repair_date = new Date(rowModel.frontInputsToUpdate.repair_date).getTime().toString();
      }
    }
    if (seHaModificadoMaterialDate) {
      if (rowModel.frontInputsToUpdate.material_date === '') {
        issueUpdateDataSupplier.material_date = null;
        issueUpdateDataSupplier.material = null;
      } else {
        issueUpdateDataSupplier.material_date = new Date(rowModel.frontInputsToUpdate.material_date).getTime().toString();
        issueUpdateDataSupplier.material = material;
      }
    }
    if (seHaModificadoComentario) {
      issueUpdateDataSupplier.add_comment_supplier = rowModel.frontInputsToUpdate.supplier_comment;
      issueUpdateDataSupplier.add_comment_supplier_name = this.supplierUser.firstname + ' ' + this.supplierUser.lastname;
    }
    if (seHaModificadoOperario) {
      issueUpdateDataSupplier.operator_num = rowModel.frontInputsToUpdate.operator_num;
    }
    return issueUpdateDataSupplier;
  }

  private setMaterial(row: IssueFront, rowModel: RowModel): number {
    let material: number; // por defecto esto es undefined
    // conversion de fechas para comparar
    const fechaAnterior = '' + row.material_date;
    const fechaActual = new Date(rowModel.frontInputsToUpdate.material_date).getTime().toString();
    if ((fechaAnterior !== null || fechaAnterior !== '') && (fechaActual === null || fechaActual === '')) {
      return material = 0;
    }
    if ((fechaAnterior === null  || fechaAnterior === '') && (fechaActual !== null || fechaActual !== '')) {
      return material = 1;
    }
    if ((fechaAnterior !== null || fechaAnterior !== '') &&
        (fechaActual !== null || fechaActual !== '') && (fechaActual !== fechaAnterior)) {
          return material = undefined;
    }
  }

  private seHaModificadoAppDate(row: IssueFront, rowModel: RowModel): boolean {
    let toReturn = false;
    let rowModelAppDate = null;
    let rowAppDate = null;
    if ('' + row.appointment_date !== '') {
      rowAppDate = row.appointment_date;
    }
    if (rowModel.frontInputsToUpdate.appointment_date !== '' && rowModel.frontInputsToUpdate.appointment_date !== null) {
      rowModelAppDate = new Date(rowModel.frontInputsToUpdate.appointment_date).getTime().toString();
    }
    if (rowAppDate !== rowModelAppDate) {
      toReturn = true;
    }
    return toReturn;
  }

  private seHaModificadoRepairDate(row: IssueFront, rowModel: RowModel): boolean {
    let toReturn = false;
    let rowModelRepairDate = null;
    let rowRepairDate = null;
    if ('' + row.repair_date !== '') {
      rowRepairDate = row.repair_date;
    }
    if (rowModel.frontInputsToUpdate.repair_date !== '' && rowModel.frontInputsToUpdate.repair_date !== null) {
      rowModelRepairDate = new Date(rowModel.frontInputsToUpdate.repair_date).getTime().toString();
    }
    if (rowRepairDate !== rowModelRepairDate) {
      toReturn = true;
    }
    return toReturn;
  }

  private seHaModificadoMaterialDate(row: IssueFront, rowModel: RowModel): boolean {
    let toReturn = false;
    let rowModelMaterialDate = null;
    let rowMaterialDate = null;
    if ('' + row.material_date !== '') {
      rowMaterialDate = row.material_date;
    }
    if (rowModel.frontInputsToUpdate.material_date !== '' && rowModel.frontInputsToUpdate.material_date !== null) {
      rowModelMaterialDate = new Date(rowModel.frontInputsToUpdate.material_date).getTime().toString();
    }
    if (rowMaterialDate !== rowModelMaterialDate) {
      toReturn = true;
    }
    return toReturn;
  }

  private seHaModificadoComentario(row: IssueFront, rowModel: RowModel): boolean {
    let toReturn = false;
    const rowModelSupplierComment = rowModel.frontInputsToUpdate.supplier_comment;
    const rowSupplierComment = row.supplier_comment;
    if (rowSupplierComment !== rowModelSupplierComment) {
      toReturn = true;
    }
    return toReturn;
  }

  private seHaModificadoOperario(row: IssueFront, rowModel: RowModel): boolean {
    let toReturn = false;
    const rowModelOperator = rowModel.frontInputsToUpdate.operator_num;
    const rowOperator = row.operator_num;
    if (rowOperator !== rowModelOperator) {
      toReturn = true;
    }
    return toReturn;
  }

  getRowIndex(row: any): number {
    let num = -1;
    this.issuePostsaleData.issuesFront.forEach((issue, k) => {
      if (issue.id === row.id) {
        num = k;
        return;
      }
    });
    return num;
  }

  getHeaderClass({ row, column, value }): any {
    if (column.prop === 'operatorFront.id') {
      return {
        'cell-right-position': true
      };
    } else {
      return {
        'cell-center-position': true
      };
    }

  }

  getCellClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };
  }

  getSupplierCommentClass({ row, column, value }): any {
    if (row.supplier_actions.includes('can_modify_supplier_comment')) {
      return {
        'is-editable': true
      };
    }
  }

  getOperatorClass({ row, column, value }): any {
    if (row.supplier_actions.includes('can_modify_operator_num')) {
      return {
        'cell-right-position': true,
        'is-editable': true
      };
    } else {
      return {
        'cell-right-position': true,
      };
    }
  }

  getDateClass({ row, column, value }): any {
    if (column.prop === 'appointment_date') {
      if (row.supplier_actions.includes('can_modify_appointment_date')) {
        if (value) {
          return {
            'is-editable': true
          };
        } else {
          return {
            'cell-empty-data': true,
            'is-editable': true
          };
        }
      }
    }
    if (column.prop === 'material_date') {
      if (row.supplier_actions.includes('can_modify_material_date')) {
        if (value) {
          return {
            'is-editable': true
          };
        } else {
          return {
            'cell-empty-data': true,
            'is-editable': true
          };
        }
      }
    }
    if (column.prop === 'repair_date') {
      if (row.supplier_actions.includes('can_modify_repair_date')) {
        if (value) {
          return {
            'is-editable': true
          };
        } else {
          return {
            'cell-empty-data': true,
            'is-editable': true
          };
        }
      }
    }
  }
}
